'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = getPreviewDataToImport;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getDateValue(value) {
  var date = new Date(value);
  var isValidDate = !isNaN(date.getTime());
  return isValidDate ? value : '';
}

function getTypeValue(value, dataType) {
  switch (dataType.name) {
    case 'String':
      return value;

    case 'Number':
      return !isNaN(Number(value)) ? value : '';

    case 'Boolean':
      return value ? 'true' : 'false';

    case 'Date':
      return getDateValue(value);

    default:
      return value || '';
  }
}

function getNormalizedFieldValue(value, attributeDef) {
  if (typeof attributeDef === 'function') {
    return getTypeValue(value, attributeDef);
  }

  if (typeof attributeDef.type === 'function') {
    return getTypeValue(value, attributeDef.type);
  }

  return value || '';
}

function getPreviewDataToImport(data, fieldsMap, attributes) {
  return data.map(function (item) {
    return _extends({}, Object.keys(fieldsMap).reduce(function (acc, field) {
      var keys = fieldsMap[field].split(',');
      var value = keys.reduce(function (accumulator, key) {
        return (accumulator + ' ' + (item[key] || '')).trim();
      }, '') || attributes[field].defaultTo;
      return _extends({}, acc, _defineProperty({}, field, getNormalizedFieldValue(value, attributes[field])));
    }, {}));
  });
}